import React from 'react';
import Grid from '@mui/material/Grid';
import { Breakpoint } from '@mui/material/styles';

export type GridSize = boolean | 'auto' | number;

export interface DashboardWidget {
    id: string;
    component: React.ReactNode;
    size: {
        xs?: GridSize;
        sm?: GridSize;
        md?: GridSize;
        lg?: GridSize;
        xl?: GridSize;
    };
}

interface DynamicDashboardProps {
    widgets: DashboardWidget[];
    maxWidth?: Breakpoint | false;
}

export default function DynamicDashboard({ widgets, maxWidth = 'xl' }: DynamicDashboardProps) {
    return (
        <Grid container spacing={3}>
            {widgets.map((widget) => (
                <Grid
                    key={widget.id}
                    size={widget.size as any}
                >
                    {widget.component}
                </Grid>
            ))}
        </Grid>
    );
}
